import React, { FC, Fragment } from 'react';
import { Divider, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { SharesItemFragment } from 'api';
import { ContentProvider } from 'providers';
import { EmptyState, Loaders, PostImage } from 'components';
import { useNotify, useSharesItems } from 'hooks';
import { ShareButton } from 'features/content/widgets';

import { IMAGE_HEIGHT } from '../constants';
import { Account, Date, Post, ShareCopy, SharePerformance } from './Partials';
import ListLoader from './ListLoader';

const useStyles = makeStyles(theme => ({
  date: {
    minHeight: 48,
  },
  divider: {
    marginTop: theme.spacing(2),
  },
  statDivider: {
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(),
  },
  item: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const SharesPast: FC = () => {
  const classes = useStyles();
  const notify = useNotify();

  const { results, isExhausted, isEmpty, isInitialLoad, sentinelRef } = useSharesItems(
    {
      scheduled: false,
      data: {
        limit: 10,
      },
    },
    {
      onError: notify.queryError,
    }
  );

  if (isInitialLoad) {
    return <ListLoader />;
  }

  if (isEmpty) {
    return <EmptyState name="past" />;
  }

  function renderActionRow(shareItem: SharesItemFragment) {
    return (
      <Grid className={classes.date} container alignItems="center" justify="space-between">
        <Grid item>
          <Date time={shareItem.share_at} />
        </Grid>
        <Grid item>
          <ContentProvider value={shareItem.content}>
            <ShareButton size="small" />
          </ContentProvider>
        </Grid>
      </Grid>
    );
  }

  function renderRow(shareItem: SharesItemFragment) {
    return (
      <div key={shareItem.id}>
        <div className={classes.item}>
          {renderActionRow(shareItem)}
          <Grid container spacing={2}>
            <Grid item>
              <PostImage size={IMAGE_HEIGHT} content={shareItem.content} />
            </Grid>
            <Grid item xs>
              <Grid container direction="column" spacing={1}>
                <Grid item>
                  <Post content={shareItem.content} />
                </Grid>
                <Grid item>
                  <Account shareItem={shareItem} />
                </Grid>
                <Grid item>
                  <ShareCopy item={shareItem} />
                </Grid>
                <Divider className={classes.statDivider} />
                <Grid item>
                  <Grid container spacing={2} alignItems="center">
                    <SharePerformance shareItem={shareItem} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Divider className={classes.divider} />
      </div>
    );
  }

  return (
    <Fragment>
      {results.map(renderRow)}
      {!isExhausted && (
        <div ref={sentinelRef}>
          <Loaders.Standard />
        </div>
      )}
    </Fragment>
  );
};

export default SharesPast;
